import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface SlabsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Slabs: React.FC<SlabsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [slabs, set_slabs] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Foundations']?.['Slabs'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Foundations': { ...b.values?.['Foundations'], 'Slabs': v } } })
    );
    const label = 'Slabs';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(slabs)}
                />
            ) : (
                <MoneyBox
                    id={'slabs'}
                    allowNegative={false}
                    value={slabs}
                    onChange={(value) => set_slabs(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
